import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { InfoLabelSize } from '../../enum/info-label-size.enum';

@Component({
  selector: 'lib-info-label',
  imports: [MatIcon],
  templateUrl: './info-label.component.html',
  styleUrl: './info-label.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InfoLabelComponent {
  leadingIconName = input<string>();
  trailingIconName = input<string>();
  size = input<InfoLabelSize>(InfoLabelSize.default);
  protected readonly InfoLabelSize = InfoLabelSize;
}
